var React = require('react');

function LanguageEng (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M12.824 5v5.676h9.137v1.688h-9.137v5.676h-1.687v-5.676H2v-1.688h9.137V5h1.687zm1.17 8.96l7.106 4.08h-7.106v-4.08zm-4.027 0v4.08H2.861l7.106-4.08zm11.994-.426v3.652l-6.36-3.652h6.36zm-13.602 0L2 17.186v-3.652h6.36zM2 5.854l6.36 3.653H2V5.854zm19.961 0v3.653h-6.36l6.36-3.653zM9.967 5v4.081L2.861 5h7.106zM21.1 5l-7.106 4.081V5H21.1z"}));
}

LanguageEng.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"#FFF"};

module.exports = LanguageEng;

LanguageEng.default = LanguageEng;
